import * as Yup from 'yup';

const isCPF = (value: string) => {
  const cleaned = value.replace(/\D/g, '');
  return cleaned.length === 11 && /^\d{11}$/.test(cleaned);
};

const isCNPJ = (value: string) => {
  const cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  // CNPJ alfanumérico: 12 caracteres alfanuméricos + 2 dígitos verificadores numéricos.
  return cleaned.length === 14 && /^[A-Z0-9]{12}\d{2}$/.test(cleaned);
};

export const DadosPrestadorValidation = Yup.object().shape({
  tipoDocumento: Yup.string()
    .required('Selecione o tipo do documento'),
  numeroDocumento: Yup.string()
    .required('Digite o número do documento')
    .test('is-valid-document', 'Verifique se o documento está correto', (value) => {
      if (!value) return false;
      return isCPF(value) || isCNPJ(value); // Aceita como válido se for CPF ou CNPJ
    }),
  nomePrestador: Yup.string()
    .required('Digite o nome do prestador'),
  uf: Yup.string()
    .required('Selecione o estado'),
  cidade: Yup.string()
    .required('Selecione a cidade')
})
